import { Container, Dropdown, Navbar } from "react-bootstrap";
import { FaCalculator, FaCog, FaPowerOff, FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PURGE } from "redux-persist";
import { logoutUser, resetUserState } from "../../../redux/actions/userAction.js";
import { backend_url_local } from "../../../server/server.jsx";
import Notifications from './Notifications.jsx';
import { useState } from "react";
import PriceCalculatorModal from '../../pages/inventory/PriceCalculatorModal.jsx';

const AdminNavbar = ({ handleShowSidebar }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.user);


  /** price calculator modal */
  const [showPriceCalculatorModal, setShowPriceCalculatorModal] = useState(false);
  const handlePriceCalculatorModalClose = () => setShowPriceCalculatorModal(false);


  // Logout currentUser
  const handleLogout = async () => {
    await dispatch(logoutUser());

    toast.success("Logged out successfully!");

    // Clear redux state
    dispatch({ type: PURGE, key: "root", result: () => null });
    dispatch(resetUserState());

    // Clear localStorage items
    localStorage.removeItem("currentShift");

    navigate("/");
  };

  const handleCalculatorClick = () => {
    setShowPriceCalculatorModal(true);
  };


  return (
    <Navbar expand="xlg" className="shadow admin-navbar fixed-top">
      <Container fluid className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center justify-content-between">
          <Navbar.Toggle
            aria-controls="admin-sidebar"
            onClick={handleShowSidebar}
            className="custom-toggle me-2"
          />
          <Navbar.Brand className="d-flex align-items-center admin-navbar-brand">
            <Link to="/admin" className="text-decoration-none">
              <h4 className="mb-0 text-white fs-xs-6">
                {currentUser?.organization?.name}
              </h4>
            </Link>
          </Navbar.Brand>
        </div>

        {/* center calculator icon */}
        <div className="d-flex justify-content-center align-items-center">
          <div onClick={handleCalculatorClick}
            className="navbar-link"
            style={{
              cursor: 'pointer',
              backgroundColor: '#007bff',
              padding: '5px',
              borderRadius: '10px',
            }}
          >
            <FaCalculator size={30} className="text-white " />
          </div>
        </div>


        <div className="d-flex align-items-center store-info border rounded px-2 me-3">
          {currentUser?.store?.name}
        </div>

        {/* Right side (Avatar dropdown) */}
        <div className="d-flex align-items-center">
          {
            (currentUser?.roleName === 'SuperAdmin' || currentUser?.roleName === 'Admin') && <Notifications />
          }
          <div className="navbar-link">
            <Dropdown align="end" className="user-profile">
              <Dropdown.Toggle as="div" className="avatar-toggle cursor-pointer d-flex align-items-center justify-content-center">
                {currentUser?.avatar ? (
                  <div className="position-relative">
                    <img
                      src={`${backend_url_local}/profile-images/${currentUser?.avatar}`}
                      alt=""
                      className="avatar-icon"
                      style={{
                        width: '30px',
                        height: '30px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        transition: 'opacity 0.3s ease'
                      }}
                      loading="lazy"
                    />
                  </div>
                ) : (
                  currentUser?.firstName && (
                    <span
                      className="avatar-letter bg-primary text-white d-flex align-items-center justify-content-center rounded-circle"
                      style={{ width: 30, height: 30 }}
                    >
                      {currentUser.firstName.charAt(0).toUpperCase()}
                    </span>
                  )
                )}
              </Dropdown.Toggle>
              <Dropdown.Menu align="end" className="user-profile-menu me-2">
                <Dropdown.Item as={Link} to="/admin/user-profile">
                  <FaUser className='me-2' /> Profile
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item as={Link} to="/admin/change-password">
                  <FaCog className='me-2' /> Change Password
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item onClick={handleLogout}>
                  <FaPowerOff className='me-2' /> Log Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </Container>
      {showPriceCalculatorModal && (
        <PriceCalculatorModal
          show={showPriceCalculatorModal}
          onHide={handlePriceCalculatorModalClose}
        />
      )}
    </Navbar>
  )
}
export default AdminNavbar;